import { cn } from "@newxsystems/shared";
import { TootAccordion } from "../../../../modules/interactive/components/TootAccordion/TootAccordion";
import { TootActions } from "../../../../modules/layout/components/TootActions/TootActions";
import { TootHeading } from "../../../../modules/layout/components/TootHeading/TootHeading";
import { TootSectionShell } from "../../../../modules/layout/components/TootSectionShell/TootSectionShell";
import { TootTechPanel } from "../../../../modules/surface/components/TootTechPanel/TootTechPanel";
import type { IAccordionBlockProps } from "./AccordionBlock.props";
import { RichTextHtml } from "../../RichTextHtml";

export const AccordionBlock = ({
  anchorId,
  buttons,
  direction,
  eyebrow,
  heading,
  items,
  mode,
  parentClass,
  spacing,
  subheading,
  variant,
}: IAccordionBlockProps) => {
  if (!items?.length) {
    return null;
  }

  const isHorizontal = variant === "horizontal";
  const hasHeader = Boolean(eyebrow || heading || subheading || buttons?.length);
  const actions = buttons?.length ? <TootActions actions={buttons} /> : undefined;
  const headerNode = hasHeader ? (
    heading ? (
      <TootHeading
        actions={actions}
        eyebrow={eyebrow}
        heading={heading}
        size="section"
        subheading={subheading}
      />
    ) : (
      <div className="flex max-w-3xl flex-col gap-4">
        {eyebrow ? <p className="toot-eyebrow">{eyebrow}</p> : null}
        {subheading ? <RichTextHtml className="toot-subheading" html={subheading} /> : null}
        {actions ? <div className="pt-2">{actions}</div> : null}
      </div>
    )
  ) : undefined;
  const accordionNode = (
    <TootAccordion
      className="h-full"
      direction={direction}
      items={items}
      label={heading ?? undefined}
      mode={mode}
    />
  );

  return (
    <TootSectionShell
      className="relative"
      header={isHorizontal ? undefined : headerNode}
      id={anchorId ?? undefined}
      rootClassName={parentClass}
      spacing={spacing ?? undefined}
      width={isHorizontal ? "wide" : "default"}
    >
      {isHorizontal ? (
        <TootTechPanel className="toot-heat-panel" showDividers={false} variant="proof">
          <div className="grid lg:grid-cols-[minmax(17rem,0.78fr)_minmax(0,1.22fr)] lg:items-stretch">
            <aside
              className={cn(
                "toot-heat-panel min-w-0 p-5 text-[var(--color-toot-foreground)] md:p-6 lg:p-7",
                direction === "ltr" && "lg:order-2",
              )}
            >
              <div className="relative">{headerNode}</div>
            </aside>
            <div className={cn("min-w-0", direction === "ltr" && "lg:order-1")}>
              {accordionNode}
            </div>
          </div>
        </TootTechPanel>
      ) : (
        <div>{accordionNode}</div>
      )}
    </TootSectionShell>
  );
};

AccordionBlock.displayName = "Block::AccordionBlock";
